import PieChart from '../components/pie/pie.vue';
import BarChart from '../components/bar/bar.vue';
import MapChart from '../components/map/map.vue';
import LineChart from '../components/line/line.vue';
import mapData from './mapData.js';

const arr1 = [

  { value: 62.4, name: '2021年' },
  { value: 52.4, name: '2022年' },
  { value: 74.4, name: '2023年' },
  { value: 58.9, name: '2024年' },
];
const arr2 = [

  { value: 95.6, name: '2021年' },
  { value: 97.6, name: '2022年' },
  { value: 125.4, name: '2023年' },
  { value: 66.3, name: '2024年' },
];
const arr3 = [

  { value: 358.6, name: '2021年' },
  { value: 334.2, name: '2022年' },
  { value: 384.5, name: '2023年' },
  { value: 379.8, name: '2024年' },
];
const arr4 = [
  { value: 625.9, name: '2021年' },
  { value: 607.5, name: '2022年' },
  { value: 658.8, name: '2023年' },
  { value: 677.6, name: '2024年' },
];
const arr5 = [
  { value: 625.9, name: '2021年' },
  { value: 607.5, name: '2022年' },
  { value: 658.8, name: '2023年' },
  { value: 677.6, name: '2024年' },
];
const arr6 = [

  { value: 301.3, name: '2021年' },
  { value: 252.2, name: '2022年' },
  { value: 393.4, name: '2023年' },
  { value: 134.5, name: '2024年' },
];
const arr7 = [

  { value: 301.3, name: '2021年' },
  { value: 252.2, name: '2022年' },
  { value: 393.4, name: '2023年' },
  { value: 134.5, name: '2024年' },
];
const arr8 = [
  { value: 185.6, name: '2021年' },
  { value: 194.1, name: '2022年' },
  { value: 308.6, name: '2023年' },
  { value: 100.1, name: '2024年' },
];
export default {
  name: 'cdyIndex',

  components: {
    PieChart,
    BarChart,
    MapChart,
    LineChart,
  },

  data() {
    return {
      progress: true,
      flag: true,
      flag1: true,
      flag2: true,
      flag3: true,
      flag4: true,
      flag5: true,
      mapData,
      mapShow: false,
      swiperlist: [
        { time: '', site: '阿鲁科尔沁旗', name: '燕麦草', price: '1350' },
        { time: '', site: '阿鲁科尔沁旗', name: '燕麦草', price: '1350' },
        { time: '', site: '阿鲁科尔沁旗', name: '燕麦草', price: '1350' },
        { time: '', site: '阿鲁科尔沁旗', name: '燕麦草', price: '1350' },
        { time: '', site: '阿鲁科尔沁旗', name: '燕麦草', price: '1350' },
        { time: '', site: '阿鲁科尔沁旗', name: '燕麦草', price: '1350' },
        { time: '', site: '阿鲁科尔沁旗', name: '燕麦草', price: '1350' },
        { time: '', site: '阿鲁科尔沁旗', name: '燕麦草', price: '1350' },
        { time: '', site: '阿鲁科尔沁旗', name: '苜蓿草', price: '1700' },
        { time: '', site: '阿鲁科尔沁旗', name: '苜蓿草', price: '1700' },
        { time: '', site: '阿鲁科尔沁旗', name: '苜蓿草', price: '1700' },
        { time: '', site: '阿鲁科尔沁旗', name: '苜蓿草', price: '1700' },
        { time: '', site: '阿鲁科尔沁旗', name: '苜蓿草', price: '1700' },
        { time: '', site: '阿鲁科尔沁旗', name: '苜蓿草', price: '1750' },
        { time: '', site: '阿鲁科尔沁旗', name: '苜蓿草', price: '1750' },
      ],
      times: '',
      imgarr: [
        {
          url: 'https://nfs.nxin.com/cms_image_859135d1-3a71-41c6-b49a-dd707a4a4cb9.png',
          show: true,
          type: 'YQ',
          name: '园区分布',
        },
        {
          url: 'https://nfs.nxin.com/cms_image_cac7a52c-c18c-49ab-9f27-2a00002863d3.png',
          show: true,
          type: 'C',
          name: '草数据',
        },
        {
          url: 'https://nfs.nxin.com/cms_image_edd6ff90-7722-4235-84b8-adbeaa48d5c8.png',
          show: true,
          type: 'N',
          name: '牛数据',
        },
        {
          url: 'https://nfs.nxin.com/cms_image_70c271ea-bedb-4be1-a334-a093e29bd814.png',
          show: true,
          type: 'M',
          name: '马数据',
        },
        {
          url: 'https://nfs.nxin.com/cms_image_4dd293cc-f816-4f5e-b497-7c4ba924bec8.png',
          show: true,
          type: 'Y',
          name: '羊数据',
        },
      ],
      leftPanel1tabs: [
        { name: '燕麦' },
        { name: '苜蓿' },
        { name: '羊草' },
        { name: '青储玉米' },
      ],
      leftPanel1active: 0,
      leftPanel2active: 0,
      leftPanel2active1: true,
      leftPanel2active2: true,
      leftPanel3active1: true,
      leftPanel3active2: true,
      leftPanel4active1: true,
      leftPanel4active2: true,
      rightPanel2active1: true,
      rightPanel2active2: true,
      rightPanel2active3: true,
      leftPanel3clor: [0, 1, 2],
      leftPanel1: {
        data: arr1,
        unit: '万吨',
        color: ['#33a7ff', '#5c17e5', '#b800ff', '#ff66e5'],
        title: '产量',
      },
      leftPanel1s: {
        data: arr2,
        unit: '万亩',
        color: ['#33a7ff', '#5c17e5', '#b800ff', '#ff66e5'],
        title: '面积',
      },
      leftPanel2tabs: [{ name: '全国' }, { name: '内蒙' }],
      leftPanel2: {
        series: [
          {
            name: '全国',
            value: [
              6119.06, 5707.54, 4843.65,
              4245, 4650.91, 6983.12, 6835.29,
            ],
            unit: '万亩',
            colors: 0,
            show: true,
          },
          {
            name: '内蒙',
            value: [
              1788.2, 1723.31, 1698.76,
              1687.5, 2008.5, 1892.7, 1938.4,
            ],
            unit: '万亩',
            colors: 1,
            show: true,
          },
        ],
        category: [
          '2018年',
          '2019年',
          '2020年',
          '2021年',
          '2022年',
          '2023年',
          '2024年',
        ],
      },
      leftPanel3: {
        series: [
          {
            name: '全国',
            value: [4397.48, 4533.87, 4565.45, 4707.43, 4397.48, 4268.33, 4485.34,],
            show: true,
            unit: '头',
            colors: 0,
          },
          {
            name: '内蒙',
            value: [375.1, 333.34, 346.76, 410.3, 363.19, 430.75, 426.75,],
            show: true,
            unit: '头',
            colors: 1,
          },
        ],
        category: [
          '2018年',
          '2019年',
          '2020年',
          '2021年',
          '2022年',
          '2023年',
          '2024年',
        ],
      },
      leftPanel4: {
        series: [
          {
            name: '全国',
            value: [65003910, 65962200, 68008050, 68481750, 63974250, 65003910, 63428330],
            colors: 0,
            unit: '头',
            show: true,
          },
          {
            name: '内蒙',
            value: [5447850, 5626500, 5000034.6, 5201360.5, 5096250, 5447850, 5965335.3],
            colors: 1,
            unit: '头',
            show: true,
          },
        ],
        category: ['2018年', '2019年', '2020年', '2021年', '2022年', '2023年', '2024年'],
      },
      rightPanel2: {
        series: [
          {
            name: '燕麦草',
            value: [2578, 2405, 2200, 2371, 2333, 2135, 2330, 2246],
            show: true,
            colors: 0,
          },
          {
            name: '青干草',
            value: [1780, 1804, 1495, 1495, 1790, 1300, 1629, 1771],
            show: true,
            colors: 1,
          },
          {
            name: '苜蓿草',
            value: [3400, 3000, 2371, 2371, 2480, 3900, 3600, 3089],
            show: true,
            colors: 2,
          },
        ],
        category: ['9月', '10月', '11月', '12月', '1月', '2月', '3月', '4月'],
      },
      rightPanel3: {
        series: [
          {
            name: '平台覆盖牛源量趋势',
            value: [
              32500, 35600, 62500, 83500, 58000, 51000, 29000, 62300, 35600, 22100, 75800,
              51000, 66000, 32300, 25600
            ],
            unit: '头',
            colors: 0,
            show: true,
          },
        ],
        category: [
          ['01月', '2023年'],
          ['02月', '2023年'],
          ['03月', '2023年'],
          ['04月', '2023年'],
          ['05月', '2023年'],
          ['06月', '2023年'],
          ['07月', '2023年'],
          ['08月', '2023年'],
          ['09月', '2023年'],
          ['10月', '2023年'],
          ['11月', '2023年'],
          ['12月', '2023年'],
          ['01月', '2024年'],
          ['02月', '2024年'],
          ['03月', '2024年'],
        ],
      },
      rightPanel4: [0, 0, 0, 0],
      business1: 653447.23,
      business2: 134542,
      business3: 0,
      business4: 0,
      businesszong: 653447.23 + 134542 + 0 + 0,
    };
  },
  created() {
    this.datalist();
    var day2 = new Date();
    day2.setTime(day2.getTime());
    var s2 = day2.getFullYear() + '-' + (day2.getMonth() + 1) + '-' + day2.getDate();
    this.times = s2
  },
  mounted() {
    this.rightPanel4 = [(this.business1 / this.businesszong).toFixed(2) * 100, (this.business2 / this.businesszong).toFixed(2) * 100, (this.business3 / this.businesszong).toFixed(2) * 100, (this.business4 / this.businesszong).toFixed(2) * 100];
    setInterval(() => {
      this.progress = false;
      this.rightPanel4 = [0, 0, 0, 0];
      setTimeout(() => {
        this.progress = true;
        this.rightPanel4 = [(this.business1 / this.businesszong).toFixed(2) * 100, (this.business2 / this.businesszong).toFixed(2) * 100, (this.business3 / this.businesszong).toFixed(2) * 100, (this.business4 / this.businesszong).toFixed(2) * 100];
        // this.rightPanel4 = [61, 19, 12, 10];
      }, 300);
    }, 8000);
  },
  methods: {
    imgarrCLick(item) {
      item.show = !item.show;
      if (item.type == 'YQ') {
        this.mapData.garden.forEach((element) => {
          element.show = !element.show;
        });
      } else if (item.type == 'C') {
        this.mapData.grass.forEach((element) => {
          element.show = !element.show;
        });
      } else if (item.type == 'N') {
        this.mapData.cow.forEach((element) => {
          element.show = !element.show;
        });
      } else if (item.type == 'M') {
        this.mapData.horse.forEach((element) => {
          element.show = !element.show;
        });
      } else if (item.type == 'Y') {
        this.mapData.sheep.forEach((element) => {
          element.show = !element.show;
        });
      }
      this.flag = !this.flag;
    },
    datalist() {
      this.$store.dispatch('manage/selectAllManageManufacturerListByGroup', {}).then((res) => {
        console.log(res);
        // res.cowList//牛
        // areaLis 园区
        const cow = res.cowList.map((item) => // 牛
        ({
          name: item.name,
          value: [item.longitude * 1, item.latitude * 1],
          datas: item.id,
          show: true,
        }));
        const garden = res.areaList.map((item) => // 园区
        ({
          name: item.name,
          value: [item.longitude * 1, item.latitude * 1],
          datas: item.id,
          show: true,
        }));
        this.mapData.cow = cow;
        this.mapData.garden = garden;
        this.$store.dispatch('manage/selectStatIndustryInfoIntegrationListByGroup', {}).then((res) => {
          // console.log(res);
          const grass = res.map((item) => // 草
          ({
            name: item.areaName,
            value: [item.longitude * 1, item.latitude * 1],
            datas: item.id,
            show: true,
          }));
          this.mapData.grass = grass;
          this.mapShow = true;
        });
        // this.mapData = {
        //   ...this.mapData,
        //   cow,
        // };
      });
    },
    leftPanel1Click(index) {
      this.leftPanel1active = index;
      this.flag1 = !this.flag1;
      let ars = [];
      let ars2 = [];
      if (index == 0) {
        ars = arr1;
        ars2 = arr2;
      } else if (index == 1) {
        ars = arr3;
        ars2 = arr4;
      } else if (index == 2) {
        ars = arr5;
        ars2 = arr6;
      } else if (index == 3) {
        ars = arr7;
        ars2 = arr8;
      }
      this.leftPanel1.data = ars;
      this.leftPanel1s.data = ars2;
    },
    leftPanel2Click1() {
      this.leftPanel2active1 = !this.leftPanel2active1;
      this.leftPanel2.series[0].show = !this.leftPanel2.series[0].show;
      this.flag2 = !this.flag2;
    },
    leftPanel2Click2() {
      this.leftPanel2active2 = !this.leftPanel2active2;
      this.leftPanel2.series[1].show = !this.leftPanel2.series[1].show;
      this.flag2 = !this.flag2;
    },
    leftPanel3Click1() {
      this.leftPanel3active1 = !this.leftPanel3active1;
      this.leftPanel3.series[0].show = !this.leftPanel3.series[0].show;
      this.flag3 = !this.flag3;
    },
    leftPanel3Click2() {
      this.leftPanel3active2 = !this.leftPanel3active2;
      this.leftPanel3.series[1].show = !this.leftPanel3.series[1].show;
      this.flag3 = !this.flag3;
    },
    leftPanel4Click1() {
      this.leftPanel4active1 = !this.leftPanel4active1;
      this.leftPanel4.series[0].show = !this.leftPanel4.series[0].show;
      this.flag4 = !this.flag4;
    },
    leftPanel4Click2() {
      this.leftPanel4active2 = !this.leftPanel4active2;
      this.leftPanel4.series[1].show = !this.leftPanel4.series[1].show;
      this.flag4 = !this.flag4;
    },
    rightPanel2Click1() {
      this.rightPanel2active1 = !this.rightPanel2active1;
      this.rightPanel2.series[0].show = !this.rightPanel2.series[0].show;
      this.flag5 = !this.flag5;
    },
    rightPanel2Click2() {
      this.rightPanel2active2 = !this.rightPanel2active2;
      this.rightPanel2.series[1].show = !this.rightPanel2.series[1].show;
      this.flag5 = !this.flag5;
    },
    rightPanel2Click3() {
      this.rightPanel2active3 = !this.rightPanel2active3;
      this.rightPanel2.series[2].show = !this.rightPanel2.series[2].show;
      this.flag5 = !this.flag5;
    },
  },
};
